import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const MatchChatButton = ({ onClick, unreadCount = 0, disabled = false }) => {
    const { t } = useTranslation();
    return (
        <ChatButton
            onClick={onClick}
            $hasUnread={unreadCount > 0}
            disabled={disabled}
            title={disabled ? t('teamDashboardPage.matchChatButtonDisabledTitle') : ''}
        >
            💬 {t('teamDashboardPage.matchChatButton')}
            {unreadCount > 0 && (
                <Badge>{unreadCount > 99 ? '99+' : unreadCount}</Badge>
            )}
        </ChatButton>
    );
};

const ChatButton = styled.button`
    background: ${props => props.$hasUnread 
        ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
        : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    };
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 24px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    box-shadow: 0 4px 12px ${props => props.$hasUnread 
        ? 'rgba(245, 87, 108, 0.3)'
        : 'rgba(102, 126, 234, 0.3)'
    };

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px ${props => props.$hasUnread 
            ? 'rgba(245, 87, 108, 0.4)'
            : 'rgba(102, 126, 234, 0.4)'
        };
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
    }

    ${props => props.$hasUnread && `
        animation: pulse 2s infinite;
        
        @keyframes pulse {
            0%, 100% {
                box-shadow: 0 4px 12px rgba(245, 87, 108, 0.3);
            }
            50% {
                box-shadow: 0 4px 20px rgba(245, 87, 108, 0.6);
            }
        }
    `}
    
    @media (max-width: 768px) {
        padding: 8px 16px;
        font-size: 13px;
        gap: 4px;
    }
`;

const Badge = styled.span`
    background: white;
    color: #f5576c;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 700;
    min-width: 20px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    
    @media (max-width: 768px) {
        padding: 2px 6px;
        font-size: 11px;
        min-width: 18px;
    }
`;

export default MatchChatButton;

